@if (!isLoading) {
  <div class="esign-frame mt-3">
    @if (signerViewUrl && (!eSignOrder || !eSignOrder.documentSigningVendor || eSignOrder.documentSigningVendor === 'DocuSign' || eSignOrder.documentSigningVendor === 'EncompassPOS' || eSignOrder.documentSigningVendor === 'SignNow')) {
      <iframe id="signing-iframe"
        class="esign-iframe"
        [src]="signerViewUrl"
        title="Document signing"></iframe>
    }

    @if (signerViewUrl && eSignOrder && eSignOrder.documentSigningVendor === 'DocMagic') {
      <iframe id="signing-iframe"
        class="esign-iframe"
        referrerpolicy="no-referrer-when-downgrade"
        sandbox="allow-forms allow-scripts allow-same-origin allow-downloads allow-popups"
        allow="camera; microphone; display-capture; fullscreen"
        [src]="signerViewUrl"
        title="Document signing"></iframe>
    }
  </div>
}
